import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class StandardActionsSubCategories extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'StandardActionsSubCategories'
  // Define default properties here
  static instanceDefaults () {
    return {
      subCategoryId: null,
      standardActionId: null,
      frameworkId: null,
      isEnabled: true,
    }
  }
}
const servicePath = 'standard-actions-sub-categories'
const servicePlugin = makeServicePlugin({
  Model: StandardActionsSubCategories,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
